import React from "react";
import ReactDOM from "react-dom/client";
import App2 from "./components/App2";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
/*--------------auth0--------*/
import { Auth0Provider } from "@auth0/auth0-react";
// swiper
import "swiper/css/bundle";
import "./components/style/styles.css";
// swiper
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>

  <Auth0Provider
    domain="dev-p3ddod3pnbhzo02l.us.auth0.com"
    clientId="iPzE7kEX5uJ0yg5dPuDQmtnESAsM3YC6"
    redirectUri={window.location.origin}
  >
    <App2 />
  </Auth0Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
